// Load data in sessionStorage
export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("s-k-account");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("s-k-account", serializedState);
  } catch {
    // ignore write errors
  }
};
